export var GlobalCssClass;
(function (GlobalCssClass) {
    GlobalCssClass["FormElement"] = "iress-form-element";
    GlobalCssClass["FormElementInvalid"] = "iress-form-element--invalid";
    GlobalCssClass["SROnly"] = "iress-sr-only";
})(GlobalCssClass || (GlobalCssClass = {}));
export var TextFieldType;
(function (TextFieldType) {
    TextFieldType["Date"] = "date";
    TextFieldType["Email"] = "email";
    TextFieldType["Number"] = "number";
    TextFieldType["Password"] = "password";
    TextFieldType["Search"] = "search";
    TextFieldType["Tel"] = "tel";
    TextFieldType["Text"] = "text";
    TextFieldType["Url"] = "url";
    TextFieldType["Time"] = "time";
})(TextFieldType || (TextFieldType = {}));
export var FormElementType;
(function (FormElementType) {
    FormElementType["Date"] = "date";
    FormElementType["Email"] = "email";
    FormElementType["Number"] = "number";
    FormElementType["Password"] = "password";
    FormElementType["Search"] = "search";
    FormElementType["Tel"] = "tel";
    FormElementType["Text"] = "text";
    FormElementType["Url"] = "url";
    FormElementType["Time"] = "time";
    FormElementType["Checkbox"] = "checkbox";
    FormElementType["Radio"] = "radio";
    FormElementType["Select"] = "select";
    FormElementType["CheckboxGroup"] = "checkbox-group";
    FormElementType["RadioGroup"] = "radio-group";
})(FormElementType || (FormElementType = {}));
export var SystemValidationStatus;
(function (SystemValidationStatus) {
    SystemValidationStatus["Error"] = "Error";
    SystemValidationStatus["Warning"] = "Warning";
    SystemValidationStatus["Success"] = "Success";
    SystemValidationStatus["Info"] = "Info";
})(SystemValidationStatus || (SystemValidationStatus = {}));
export var FieldErrorType;
(function (FieldErrorType) {
    FieldErrorType["PatternMismatch"] = "patternMismatch";
    FieldErrorType["RangeOverflow"] = "rangeOverflow";
    FieldErrorType["RangeUnderflow"] = "rangeUnderflow";
    FieldErrorType["TooLong"] = "tooLong";
    FieldErrorType["TooShort"] = "tooShort";
    FieldErrorType["TypeMismatch"] = "typeMismatch";
    FieldErrorType["StepMismatch"] = "stepMismatch";
    FieldErrorType["ValueMissing"] = "valueMissing";
})(FieldErrorType || (FieldErrorType = {}));
export var HeadingLevel;
(function (HeadingLevel) {
    HeadingLevel["H1"] = "h1";
    HeadingLevel["H2"] = "h2";
    HeadingLevel["H3"] = "h3";
    HeadingLevel["H4"] = "h4";
    HeadingLevel["H5"] = "h5";
    HeadingLevel["H6"] = "h6";
})(HeadingLevel || (HeadingLevel = {}));
//# sourceMappingURL=interfaces.js.map